export const zIndex = {
  header: 9,
  banner: 9,
  modal: 10,
}

export default zIndex
